
<div v-if="windowWidth > 1024" class="flex flex-col h-[99rem] px-[6.375rem] relative">
  <div
    class="sticky h-[calc(33rem-60px)] flex top-[60px] left-0 pr-[calc(6.375rem/2)]"
    style="width: 50%;"
  >
    <transition :name="`${slideDirection}-slide-fade`" mode="out-in">
      <div
        :key="currentDescription.key"
        class="flex flex-col"
      >
        <h3>
          {{ currentDescription.title }}
        </h3>
        <p class="!text-[1rem] !leading-[1.5rem]">
          {{ currentDescription.description }}
        </p>
      </div>
    </transition>
  </div>
  <div
    class="flex flex-col absolute right-0 pl-[calc(6.375rem/2)]"
    style="width: 50%;"
  >
    <span
      v-for="({id, image, imageAlt}, index) in flattenContainerImgsMapping"
      :key="index"
      :id="id"
      class="h-[33rem] w-[25.5rem] flex items-start justify-center"
    >
      <img
        :src="image"
        :alt="imageAlt"
      />
    </span>
  </div>
</div>
<div v-else class="flex flex-col gap-6">
  <div
    v-for="({containerImage, description}, index) in mixedFlattenContainerImgsAndDescriptions"
    :key="index"
  >
    <div class="flex flex-col">
      <div class="flex flex-col">
        <h3>
          {{ description.title }}
        </h3>
        <p class="!text-[1rem] !leading-[1.5rem]">
          {{ description.description }}
        </p>
      </div>
      <span class="w-full flex items-center justify-center">
        <img
          :src="containerImage.image"
          :alt="containerImage.imageAlt"
        />
      </span>
    </div>
  </div>
</div>
